export const updatesDataSelector = state => ({
  isUpdatesFetched: state.updatesData.isUpdatesFetched,
  isUpdatesLoading: state.updatesData.isUpdatesLoading,
  updatesData: state.updatesData.updatesData
});

export const updateNotification = state => state.updatesData.isNewUpdate;